// extracted by mini-css-extract-plugin
export default {"container":"bRJPqk","item":"ySR5aK"};